(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('SingleStoreNavController', ['$scope', '$state', 'storeId', 'store', '$uibModal', '$timeout', '$rootScope', '$localForage', '$Orders', function($scope, $state, storeId, store, $uibModal, $timeout, $rootScope, $localForage, $Orders) {


        angular.extend($scope, {

            init: () => {

                $scope.store = store;

            },

            numberOfThingsInTheCar: function() {

                // return $root.cart.products.length + $root.cart.packages.length;

            },

            showCart: function() {

                let self = this;

                $uibModal.open({
                    animation: true,
                    windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                    templateUrl:'directives/externalStore/cart.html',
                    controller: function($scope, $uibModalInstance) {

                        console.log('cart', $rootScope.cart);

                        $scope.close = () => {

                            $uibModalInstance.close();

                        }

                        $scope.showCheckout = () => {

                            $uibModalInstance.close();

                            self.showCheckout();

                        }

                        $scope.removeItem = (item, index) => {

                            self.removeItem(item, index);

                        }

                        $scope.removePackage = (item, index) => {

                            self.removePackage(item, index);

                        }

                    }
                });
            },

            showCheckout: function() {

                console.log('cart', $rootScope.cart);

                let self = this;

                if(!$rootScope.cart){
                    alert('You have no products in your cart. Please add something to your cart and try again.');
                } else {
                    $uibModal.open({
                        animation: true,
                        windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                        templateUrl:'directives/externalStore/checkout.html',
                        controller: 'CheckoutController',
                        resolve: {
                            store: function(){
                                return store;
                            },
                            storeId: function() {
                                return storeId;
                            }
                        }
                    });
                }
            },

            test: function() {
                // $scope.showThankYou('blllop')
            },

            emptyCart: () => {

                $rootScope.cart = {};
                $rootScope.$emit('cart.products.removed');

            },

            removeItem: function(item, index) {

                // console.log('item', item, index);

                _.pullAt($rootScope.cart.products, index);

                $rootScope.$emit('cart.product.removed');

            },

            removePackage: function(item, index) {

                // console.log('item', item, index);

                _.pullAt($rootScope.cart.packages, index);

                $rootScope.$emit('cart.package.removed');

            }

        });

        $scope.init();

        $rootScope.$on('cart.empty', function() {
            $scope.emptyCart();
        });

        $rootScope.$on('cart.show', function() {
            $scope.showCart();
        });

    }]);

})();
